<template>
  <div :style="$cmsStyles('c_a7e2c1d124eb')" class="container">
    <tools-bar ref="toolsBar"></tools-bar>
    <div class="main-content">
      <div v-show="$cms('c_a7e2c1d124eb', 'f_0001', true)" class="process-introduction">
        <h1 class="title">{{ $cms('c_a7e2c1d124eb', 'f_0002', "申请流程") }}</h1>
        <div class="process-list">
          <div class="process-item" v-for="item in processList" :key="item.title">
            <div class="icon-box">
              <img :src="item.icon" alt="">
            </div>
            <div class="title">{{ item.title }}</div>
          </div>
        </div>
      </div>
      <div class="form-wrapper">
        <div class="form-inner">
          <type1-form 
            v-if="type === 1" 
            ref="type1Form"
            :is-submitting="isSubmitting"
            @submit="handleFormSubmit"
            @upload-success="onUploadSuccess"
            @upload-error="onUploadError"
          />
          <type2-form 
            v-if="type === 2" 
            ref="type2Form"
            :is-submitting="isSubmitting"
            @submit="handleFormSubmit"
            @upload-success="onUploadSuccess"
            @upload-error="onUploadError"
          />
          <type3-form 
            v-if="type === 3" 
            ref="type3Form"
            :is-submitting="isSubmitting"
            @submit="handleFormSubmit"
          />
          <type4-form 
            v-if="type === 4" 
            ref="type4Form"
            :is-submitting="isSubmitting"
            @submit="handleFormSubmit"
          />
          <type5-form 
            v-if="type === 5" 
            ref="type5Form"
            :is-submitting="isSubmitting"
            @submit="handleFormSubmit"
            @upload-success="onUploadSuccess"
            @upload-error="onUploadError"
          />
        </div>
        <img class="form-bg"
:src="$cms('c_a7e2c1d124eb', 'f_0003', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250806141304240000866.17544607840582677.png&quot;)"
        alt="">
      </div>
    </div>
  </div>
</template>

<script>
import ToolsBar from '@/components/ToolsBar.vue'
import Type1Form from '@/components/apply-join/Type1Form.vue'
import Type2Form from '@/components/apply-join/Type2Form.vue'
import Type3Form from '@/components/apply-join/Type3Form.vue'
import Type4Form from '@/components/apply-join/Type4Form.vue'
import Type5Form from '@/components/apply-join/Type5Form.vue'
import { convertKeysToChinese } from '@/components/apply-join/fieldMappings.js'
import { sendEmail } from '@/service/api';

export default {
  components: {
    ToolsBar,
    Type1Form,
    Type2Form,
    Type3Form,
    Type4Form,
    Type5Form,
  },
  head() { return this.$cmsHead('c_a7e2c1d124eb', {
    title: '申请合作-主播合作申请-品牌合作申请-渠道合作申请-魔筷科技',
    meta: [
      {
        name: 'Keywords',
        content:
          '主播合作申请,品牌合作申请,渠道合作申请,直播带货合作,主播签约,品牌入驻,渠道招募,合作基地,直播电商合作,魔筷科技',
      },
      {
        name: 'Description',
        content:
          '魔筷科技提供多种合作申请渠道：主播合作申请、品牌合作申请、渠道合作申请、合作基地招募等。专业直播电商服务机构，为主播、品牌方、渠道商提供一站式合作解决方案，助力直播电商行业发展。',
      },
    ],
  }); },

  data() {
    return {
      type: '',
      isSubmitting: false, // 提交状态
      processList: this.$cms('c_a7e2c1d124eb', 'f_0004', [{"icon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250806141304240000382.17544607840551078.png","title":"提交申请"},{"icon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250806141304240000864.17544607840605407.png","title":"线下审核"},{"icon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250806141304240000131.17544607840607899.png","title":"洽谈方案"},{"icon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250806141304240000225.17544607840595266.png","title":"签约合作"}])
    }
  },
  created() {
    if (this.$route.query.type) {
      this.type = Number(this.$route.query.type);
    } else {
      this.type = 1;
    }
  },
  mounted() {
    // this.initFullpage()
    this.$refs.toolsBar.show()
  },
  methods: {
    onUploadSuccess(url) {
      console.log('文件上传成功:', url);
    },

    onUploadError(error) {
      console.error('上传失败:', error);
      this.$message.error('文件上传失败');
    },

    // 处理表单提交
    handleFormSubmit(formData) {
      if (this.isSubmitting) {
        return; // 如果正在提交，直接返回
      }
      
      this.isSubmitting = true; // 开始提交
      
      // 转换字段名为中文
      const chineseFormData = convertKeysToChinese(formData, this.type);
      
      sendEmail({
        emailInfo: JSON.stringify(chineseFormData),
        type: this.type,
      }).then(() => {
        this.$message.success('申请提交成功！');
      }).catch(() => {
        this.$message.error('申请提交失败，请重试');
      }).finally(() => {
        this.isSubmitting = false; // 提交完成，重置状态
      });
    }
  },
}
</script>

<style lang="less" scoped>
@import "../style/common.less";

.main-content {
  padding-top: 90px;
}

.process-introduction {
  .pxToVw(height, 443);
  .pxToVw(padding-top, 80);
  .pxToVw(padding-bottom, 80);
  box-sizing: border-box;
  background: #FFF;
  text-align: center;

  h1.title {
    font-weight: 600;
    .pxToVw(font-size, 36);
    color: #333333;
    .pxToVw(line-height, 50);
    .pxToVw(margin-bottom, 60);
  }

  .process-list {
    .pxToVw(width, 1200);
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    .process-item {
      position: relative;
      text-align: center;

      .icon-box {
        .pxToVw(width, 120);
        .pxToVw(height, 120);
        .pxToVw(border-radius, 60);
        background: rgba(255, 255, 255, 0.8);
        box-shadow: 0px -4px 39px 0px rgba(197, 202, 220, 0.21);
        border: 1px solid #FFFFFF;
        backdrop-filter: blur(18px);
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          .pxToVw(width, 45);
        }

        &::before {
          content: '';
          position: absolute;
          top: 50%;
          .pxToVw(left, 147);
          transform: translateY(-50%);
          background-image: var(--cms-c_a7e2c1d124eb-f_0005, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250806143336890000549.17544620166648621.png"));
          background-size: 100% 100%;
          background-repeat: no-repeat;
          .pxToVw(width, 189);
          .pxToVw(height, 16);
        }
      }

      .title {
        .pxToVw(font-size, 24);
        .pxToVw(line-height, 33);
        .pxToVw(margin-top, 20);
        color: #333333;
        font-weight: 600;
      }

      &:last-child {
        .icon-box {
          &::before {
            display: none;
          }
        }
      }
    }
  }
}

.form-wrapper {
  .pxToVw(padding-top, 80);
  .pxToVw(padding-bottom, 80);
  box-sizing: border-box;
  text-align: center;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #FFF;
    filter: blur(10px);
    z-index: 0;
  }

  .form-inner {
    position: relative;
    z-index: 1;
    .pxToVw(width, 1200);
    margin: 0 auto;
  }

  .form-bg {
    position: absolute;
    .pxToVw(width, 483);
    .pxToVw(bottom, 0);
    .pxToVw(right, 0);
    z-index: 0;
  }
}
</style>
